
import { Card, Container, Input, FormButton, Text, Checkbox } from "../components/UI"
import { useState, useEffect } from "react"
import { useForm, Controller } from "react-hook-form";
import { Link, useSearchParams } from "react-router-dom";
import { APP_SETTINGS } from "../hooks/useAppSettings";
import { useController } from "../hooks/useController";
import { useUserData } from "../hooks/useUserData";

export const Activate = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const email = searchParams.get("email");
    const securityStamp = searchParams.get("securitystamp");
    const {postData: send, response,data, error, isLoading} = useController();
    const {lang} = useUserData();
    const activateAccount = async () =>{
        await send(`${APP_SETTINGS.api}/Account/Verify?email=${email}&securityStamp=${securityStamp}`,'POST');
    }
    useEffect(()=>{
        activateAccount();
    },[])
    return(
        <>

           
            <Card>
                <Container>
                {
                    response?.ok 
                     ?
                    
                    <>
                    <Text role="h1">{lang?.congrats}!</Text>
                    <Text role="h2">{lang?.yourAccountIsActive}!<Link to={`/`}>Login now.</Link></Text>
                    </>
                    :
                    <>
                    <Text role="h1">{lang?.error}!</Text>
                    <Text role="h2">{lang?.yourAccountIsNotActive}! </Text>
                    </>
                }
                
                </Container>
                
            </Card>
        
        </>
    )

}
